"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const react_1 = __importDefault(require("react"));
const Thread_styles_1 = require("../../../Thread.styles");
/**
 * Customised Button component
 * Will extend the full width of the container it's inserted into
 */
const ActionButton = (props) => {
    return react_1.default.createElement(Thread_styles_1.StyledActionButton, Object.assign({}, props));
};
exports.ActionButton = ActionButton;
//# sourceMappingURL=ActionButton.js.map